import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../../ui/molecules/textArea"
import { skillLevels } from "../../../../utils"
import { OtherInfoCreation, OtherInfoValidation, resetErrorLabel, resetOtherInfoCreateForm, resetOtherInfoValidationStatus, setDrivingLicense, setNativeLanguage, setOralExpressionSkill, setOrganizationalSkill, setOtherLanguage, setOtherSkill, setPersonalSkill, setReadSkill, setRelationalSkill, setTechnicalSkill, setWriteSkill } from "../slice"

interface Props {
    close: () => void;
}

export default function AddOtherInfo(props: Props) {
    const dispatch = useAppDispatch()
    const otherInfoState = useAppSelector(state => state.PMOtherInfo)

    useEffect(() => {
        if (otherInfoState.OtherInfoValidationStatus === 'successfully') {
            dispatch(resetOtherInfoValidationStatus())
            dispatch(resetErrorLabel())
            dispatch(OtherInfoCreation(otherInfoState.otherInfoCreationRequest))
            props.close()
            dispatch(resetOtherInfoCreateForm())
        }
    }, [otherInfoState.OtherInfoValidationStatus])

    return (
        <>
            <div className="p-6 bg-white flex flex-col gap-6">

                {otherInfoState.errorLabel && (
                    <div className="rounded-lg bg-red-100 px-4 py-3">
                        <span className="text-sm font-semibold text-red-700">
                            {otherInfoState.errorLabel}
                        </span>
                    </div>
                )}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <MadfarmInput
                        label="Patente (Es. A, A1, B, ecc.)"
                        placeholder="Patente"
                        value={otherInfoState.otherInfoCreationRequest.drivingLicense}
                        defaultValue={otherInfoState.otherInfoCreationRequest.drivingLicense}
                        onChangeText={(text) => dispatch(setDrivingLicense(text))}
                    />
                    <MadfarmInput
                        label="Madrelingua"
                        placeholder="Madrelingua"
                        value={otherInfoState.otherInfoCreationRequest.nativeLanguage}
                        defaultValue={otherInfoState.otherInfoCreationRequest.nativeLanguage}
                        onChangeText={(text) => dispatch(setNativeLanguage(text))}
                    />
                    <MadfarmInput
                        label="Altre lingue (Francese, Inglese, ecc..)"
                        placeholder="Specificare altre lingue..."
                        value={otherInfoState.otherInfoCreationRequest.otherLanguage}
                        defaultValue={otherInfoState.otherInfoCreationRequest.otherLanguage}
                        onChangeText={(text) => dispatch(setOtherLanguage(text))}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Capacità linguistiche</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Capacità di lettura"
                        placeholder="Specificare capacità"
                        options={skillLevels}
                        value={otherInfoState.otherInfoCreationRequest.readSkill}
                        defaultValue={otherInfoState.otherInfoCreationRequest.readSkill}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setReadSkill(newValue))
                        }}
                        noOptionsMessage={""}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Capacità di scrittura"
                        placeholder="Specificare capacità"
                        options={skillLevels}
                        value={otherInfoState.otherInfoCreationRequest.writeSkill}
                        defaultValue={otherInfoState.otherInfoCreationRequest.writeSkill}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setWriteSkill(newValue))
                        }}
                        noOptionsMessage={""}
                    />
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Capacità di espressione orale"
                        placeholder="Specificare capacità"
                        options={skillLevels}
                        value={otherInfoState.otherInfoCreationRequest.oralExpressionSkill}
                        defaultValue={otherInfoState.otherInfoCreationRequest.oralExpressionSkill}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setOralExpressionSkill(newValue))
                        }}
                        noOptionsMessage={""}
                    />
                </div>

                <div className="border-t border-neutral-200 pt-2">
                    <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Competenze</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <TextArea
                        label="Capacità e competenze personali"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.otherInfoCreationRequest.personalSkill}
                        defaultValue={otherInfoState.otherInfoCreationRequest.personalSkill}
                        onChangeText={(text) => dispatch(setPersonalSkill(text))}
                    />
                    <TextArea
                        label="Capacità e competenze relazionali"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.otherInfoCreationRequest.relationalSkill}
                        defaultValue={otherInfoState.otherInfoCreationRequest.relationalSkill}
                        onChangeText={(text) => dispatch(setRelationalSkill(text))}
                    />
                    <TextArea
                        label="Capacità e competenze organizzative"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.otherInfoCreationRequest.organizationalSkill}
                        defaultValue={otherInfoState.otherInfoCreationRequest.organizationalSkill}
                        onChangeText={(text) => dispatch(setOrganizationalSkill(text))}
                    />
                    <TextArea
                        label="Capacità e competenze tecniche"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.otherInfoCreationRequest.technicalSkill}
                        defaultValue={otherInfoState.otherInfoCreationRequest.technicalSkill}
                        onChangeText={(text) => dispatch(setTechnicalSkill(text))}
                    />
                </div>

                <div className="grid grid-cols-1 gap-4">
                    <TextArea
                        label="Altre capacità e competenze"
                        placeholder="Specificare capacità..."
                        value={otherInfoState.otherInfoCreationRequest.otherSkill}
                        defaultValue={otherInfoState.otherInfoCreationRequest.otherSkill}
                        onChangeText={(text) => dispatch(setOtherSkill(text))}
                    />
                </div>

                <div className="flex justify-end gap-2 pt-4 border-t border-neutral-200">
                    <ButtonComponent
                        size="md"
                        variant="outline"
                        iconPosition="off"
                        label="Annulla"
                        color="gray"
                        onClick={() => props.close()}
                    />
                    <ButtonComponent
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(OtherInfoValidation(otherInfoState.otherInfoCreationRequest))}
                    />
                </div>
            </div>
        </>
    )
}